import React, { Component } from 'react';
import { runInAction } from "mobx";
import { inject, observer } from "mobx-react";
import i18n from "i18next";

import validate from '../../utilities/validation-rules';

import RowText from '../form-rows/row-text';

import TextInput from '../../elements/form-input-text';
import Select from '../../elements/form-input-select';

const FormAddress = inject("stores") (
    observer (
        class FormAddress extends Component {

            constructor(props) {
                super(props);
                this.props = props;

                this.storeAuth = this.props.stores.storeAuth;
                this.storeUi = this.props.stores.storeUi;
                this.storeUsers = this.props.stores.storeUsers;
                this.storeForms = this.props.stores.storeForms;

                this.state = {
                    formControls: { 
                        street: {
                            type: "text",
                            label: i18n.t("forms.label.street"),
                            value: '',
                            placeholder: i18n.t("forms.placeholder.delivery_street"),
                            validationRules: {
                                isRequired: true
                            },
                            valid: true
                        },
                        housenr: {
                            type: "text",
                            label: i18n.t("forms.label.housenr"),
                            value: '',
                            placeholder: i18n.t("forms.placeholder.housenr"),
                            validationRules: {
                                isRequired: true
                            },
                            valid: true
                        },
                        addition: {
                            type: "text",
                            label: i18n.t("forms.label.addition"),
                            value: '',
                            placeholder: i18n.t("forms.placeholder.addition"),
                            validationRules: {
                            },
                            valid: true
                        },
                        zipcode: {
                            type: "text",
                            label: i18n.t("forms.label.zipcode"),
                            value: '',
                            placeholder: i18n.t("forms.placeholder.delivery_zipcode"),
                            validationRules: {
                                isRequired: true,
                            },
                            valid: true,
                            required: true
                        },
                        city: {
                            type: "text",
                            label: i18n.t("forms.label.city"),
                            value: '',
                            placeholder: i18n.t("forms.placeholder.delivery_city"),
                            validationRules: {
                                isRequired: true,
                            },
                            valid: true,
                            required: true
                        },
                        // country_select: {
                        //     label: i18n.t("forms.label.country"),
                        //     value: 'NL',
                        //     placeholder: i18n.t("forms.placeholder.country"),
                        //     touched: false,
                        //     validationRules: {
                        //         //isRequired: true,
                        //     },
                        //     options: this.storeUi.countriesList
                        // }
                    },
                    formIsValid: false
                }
            }

            componentDidMount = async() => {
                let userId;
                
                if (this.storeAuth.user.isLoggedin) {
                    userId = this.storeAuth.user.accountId;
                } else {
                    (async() => await this.storeAuth.getGuestId())();
                    userId = this.storeAuth.user.guestId;
                }

                if (userId !== 0) {
                    const address = await this.storeUsers.getAddress(userId);
                    this.setState({
                        address: address
                    }, () => this.initForm())
                }
            }

            componentDidUpdate = async(prevProps) => {
            }

            initForm = async() => {
                let name = '';
                let value = '';
                
                name = 'street';
                value = this.state.address.invoiceStreet;
                await this.initRow(name, value);

                name = 'housenr';
                value = this.state.address.invoiceHousenr;
                await this.initRow(name, value);

                name = 'addition';
                value = this.state.address.invoiceAddition;
                await this.initRow(name, value);

                name = 'zipcode';
                value = this.state.address.invoiceZipcode;
                await this.initRow(name, value);

                name = 'city';
                value = this.state.address.invoiceCity;
                await this.initRow(name, value);
            }

            initRow = async(name, value) => {
                let valid;
                valid = (value !== null && value !== '') ? true : false;

                const updatedControls = this.storeForms.validateRow(this.state.formControls, name, value, valid);

                this.setState({
                    formControls: updatedControls
                })
            }

            validateRow = (name, value, valid) => {        
                const updatedControls = this.storeForms.validateRow(this.state.formControls, name, value, valid);

                this.setState({
                    formControls: updatedControls
                }, () => this.validateForm()); 
            }

            validateForm = () => {
                const formIsValid = this.storeForms.validateForm(this.state.formControls);
                console.log('Sbc valid form address', formIsValid)
                this.props.handleBtnAddress(formIsValid);

                this.setState({
                    formIsValid: formIsValid,
                    feedback: false,
                    btn_class: formIsValid ? '--active' : '--disabled'
                }, () => this.saveAddress());
            }

            saveAddress = () => {
                const data = this.state.formControls;
                if (this.storeAuth.user.isLoggedin) {
                    this.storeUsers.saveAddress('account', this.storeAuth.user.accountId, data);
                } else {
                    this.storeUsers.saveAddress('guest', this.storeAuth.user.guestId, data);
                }
            }
          
            render() {
                return (
                    <form className="form">
                        {Object.keys(this.state.formControls).map((key, i) => (
                            <React.Fragment>
                                {key !== "country_select" &&                               
                                    <React.Fragment>
                                        {(this.state.formControls[key].type === "text" || this.state.formControls[key].type === "email" || this.state.formControls[key].type === "password") &&
                                            <RowText 
                                                type = {this.state.formControls[key].type}
                                                name = {key}
                                                value = {this.state.formControls[key].value}
                                                validationRules = {this.state.formControls[key].validationRules}
                                                validationMsg = {this.state.formControls[key].validationMsg}
                                                onValidate = {this.validateRow}
                                                disable = {this.state.formControls[key].disable}
                                            />
                                        }
                                    </React.Fragment>
                                } 

                            </React.Fragment>
                        ))}
                    </form>
                )
            }
        }
    )
)

export default FormAddress;
